export const ds_ImageAccordionBlock_Entry = `
    fragment ds_ImageAccordionBlock_Entry on ds_ImageAccordionBlock_Entry {
        id
        canonicalUid

        imageAccordion_ColorTheme
        imageAccordion_ColorPalette
        imageAccordion_FullWidthBackground
        imageAccordion_TopSpacing
        imageAccordion_ContainerWidth
        imageAccordion_HeadingOrientation
        imageAccordion_ShowSubheading
        imageAccordion_Gradient
        imageAccordion_ContentPosition
        imageAccordion_ContentAlignment
        imageAccordion_ContentPositionExpanded
        imageAccordion_AccordionWidth
        imageAccordion_HideImage
        imageAccordion_Palette
        imageAccordion_ExpandedPalette
        imageAccordion_SpaceBetween
        
        imageAccordion_ImageAccordionItems {
            ... on ds_ImageAccordionItem_Entry {
                imageAccordionItem_Image {
                    url @transform (width: 1024, height: 768)
                    alt
                    focalPoint
                }
                imageAccordionItem_Icon {
                    name
                    set
                    type
                }
                imageAccordionItem_Subheading
                imageAccordionItem_Heading
                imageAccordionItem_LeadText
                imageAccordionItem_BodyText
                imageAccordionItem_HeadingSize
                imageAccordionItem_Button {
                    text
                    target
                    title
                    url
                    ariaLabel
                    ... on imageAccordionItem_Button_Custom_LinkType {
                        buttonStyle
                    }
                    ... on imageAccordionItem_Button_Entry_LinkType {
                        buttonStyle
                    }
                    ... on imageAccordionItem_Button_Url_LinkType {
                        buttonStyle
                    }
                    ... on imageAccordionItem_Button_Phone_LinkType {
                        buttonStyle
                    }
                    ... on imageAccordionItem_Button_Email_LinkType {
                        buttonStyle
                    }
                }
            }
        }
    }
`